import { IGenericListItem } from "./IGenericList";
import { InternalTypeEnum } from "../models/InternalTypeEnum";
import { IUploadPath } from "./IUserModel";

// -- Commun avec le client en dessous 

export interface ImageContent {
	mimetype: string;
	data: string;
}

export interface IViewContext {
	FunctionName: string;		// Nom de la vue
	IdSession: string			// Identifiant de la session
	IdTransaction: string;      // Identifiant de la transaction en cours
	IdSite: string;				// Identifiant du site courant
	Description: string        // Description longue IO_FUNDESLNG
	Controls: IControl[]		// Symboles
	Actions: IAction[]			// Actions
	TableDefs: ITable[];     // D�finition des tableaux
	Step: number;

	Attributes: string;         // Flux JSON pour les attributs
	Images: ImageContent[];
	Texts: string[];
	MultiAnswers: string[];

	Context: string;

	LandscapeNbCols: number;
	DisableHomeRedirection: boolean;
	ViewEmbeddedDoc: boolean;

	IsWidget: boolean;
}

export interface IControlBase {
	Id: number,             // IO_SYMLIN, IO_BRANG (bouton)
	Code: string,           // IO_S, IO_KMABOU (bouton)
	Type: ControlTypeEnum,  // ControlTypeEnum.action (bouton)

	Visible: boolean;		// BSAI
	Disable: boolean;		// BSAI
}

// X1WS_APCTX_RESULT_GRP2
// D�finition du flux pour les symboles
export interface IControl extends IControlBase {
	Description: string,    // IO_SYMDES -- La petite description qui va bien
	Value: string,			// IO_SYMVAL -- Valeur de la zone de saisie
	NoLabel: number,        // O_NOLIB -- N� du menu local
    Label: string,          // O_LIBDEF
    TypeLenght: number,     // IO_ZLNGTYP -- longueur du champ
	Complement1: string,    // O_SYMCPT1
	Complement2: string,    // O_SYMCPT2
	Complement3: string,    // O_SYMCPT3
	DataType: InternalTypeEnum,	// O_ZTYPTYP
	Popup: string,			// IO_ZPOPUP
	Content: string		
}

// X1WS_APCTX_RESULT_GRP3
// d�finition des boutons
export interface IAction extends IControlBase {
	Text: string,           // IO_BDES
	WebService: string,     // IO_BWS
	Target: number,         // IO_BMANAGEMENT
	Context: string,        // IO_BCONTEXT
	Action: number,         // IO_BACTION
	//URL: string;
}

// D�finition d'un tableau
export interface ITable extends IControlBase {
	Code: string;				// Code du tableau pour le retrouver depuis la liste des symboles
	Description: string;
	ColDefs: IColumnDef[],
	Rows: any[],
	SelectedRow: IRowDefinition,
	Actions: IAction[],			// Actions associ�es au tableau
	NewRows: string;			// UTilis� pour remonter les lignes nouvellement cr��es (format csv)
}

// D�finition d'une colonne
export interface IColumnDef extends IControlBase {
	Title: string,

	IsMerged: boolean,

	// Binding
	FieldName: string,
	SearchFieldName: string,
	ColType: InternalTypeEnum,
	Class: string,
}


// Visible & DIsable 
// Calcul�s depuis SYMAFF (VisibilityEnum)
//             Visible   |   Disable 
// Edit     :   True     |    False
// ReadOnly :   True     |    True
// Hidden   :   False    |    True
// Control   :   False    |    True

// Correspond au type X3 
// Menu local 20106
export enum ControlTypeEnum {
	label = 1,				// Libell� texte
	input = 2,				// Zone saisie
	select = 3,				// Liste de choix g�n�rique
	checkbox = 4,			// Case � cocher
	table = 5,				// Tableau
	selectControled = 6,	// Table contr�l�e impos�e
	selectFree = 7,			// Table contr�l�e libre
	image = 8,				// Image

	viewerRTF = 9,			// RTF
	viewerHtml = 10,		// Visualiseur de contenu HTML 

	selectDynamic = 11,		// List dynamique
	document = 12,			// Pi�ces jointes

	progress = 13,			// Barre de progression 
	jauge = 14,				// jauge

	htmlEditor = 15,		// Editeur HTML 

	// Internal use - permet l'impl�mentation de ICOntrolBase sur les type action & colonnes
	column = 100,
	action = 101,
}

export enum ListTypeEnum {
	select = 3,
	selectControled = 6,
	selectFree = 7,
}

//// Menu local 936
//export enum SymAffEnum {
//	Edit = 1,
//	ReadOnly = 2,
//	Hidden = 3,
//	// Unused
//	Symbol = 4,
//}

export interface IViewContextParams {
	fnct: string,
	title: string,
	context: string,
	idSession: string;
	idTransaction: string;
	barCode: string,
	etape: number,
	idSite: string,
	Controls: IControl[];			// Symboles
	Tables: ITable[];	        // Tableaux
	Actions: IAction[];
	uploadedFiles: IUploadPath[];	// Liste des fichiers pr�c�demment upload�s et en attente de validation
}

export interface IGetDynListParams {
	kmaZone: string,
	flxCod: string,
	site: string,
	filters: IGenericListItem[],
}

// D�finition d'un ligne de tableau
// Chaque ligne contient son identifiant unique ainsi que les cellules/colonnes
export interface IRowDefinition {
	key: string,
	columns: ICellDefinition[]
}

export interface ICellDefinition {
	cellName: string,	// Correspond au nom de la colonne
	cellValue: string,
}

